import { motion } from "framer-motion";
import { waLink } from "./constants";
import { WhatsAppIcon } from "./Icons";

export const FloatingWhatsApp = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Conversar no WhatsApp"
    data-testid="floating-whatsapp-btn"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 15 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="group fixed bottom-5 right-5 z-40 flex items-center gap-3 sm:bottom-8 sm:right-8"
  >
    <span className="font-mono-x hidden rounded-full bg-[#0c0a09] px-4 py-2 text-xs uppercase tracking-[0.15em] text-[#FACC15] opacity-0 transition-opacity duration-300 group-hover:opacity-100 sm:block">Orçamento rápido</span>
    <span className="relative grid h-16 w-16 place-items-center rounded-full border-4 border-[#0c0a09] bg-[#FACC15] text-[#0c0a09] shadow-[0_12px_30px_-6px_rgba(0,0,0,0.6)]">
      <span className="absolute inset-0 animate-ping rounded-full bg-[#FACC15]/50 [animation-duration:2.4s]" />
      <WhatsAppIcon className="relative h-7 w-7" />
    </span>
  </motion.a>
);
